/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import 'core-js/features/object/assign';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import routes from './router/routes';
import { path } from 'ramda';
import pageVisibility from './page-visibility';
import RequestService from './service/requestService';

import './assets/styles/main.scss'; // load scss
import './assets/fonts/_fonts.scss';
import '@signanthealth/modular-ui/styles/base.css';
import { SecurityWrapper } from '@signanthealth/modular-ui';
import { APPLICATION_PATH, oktaClient } from './service/oktaAuth';

// getCookie :: String -> String | null
function getCookie(name) {
  let cookie = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return cookie ? cookie[2] : null;
}

// isDefined :: * -> * -> Boolean
const isDefined = (x) => x !== null && x !== undefined;

function checkCookieSync() {
  const tenantId = path(['sponsor', 'selectedSponsor', 'id'], store.getState());
  const cookieTenantId = getCookie('tc_tenant_id');

  if (isDefined(tenantId) && isDefined(cookieTenantId) && String(tenantId) !== cookieTenantId)
    RequestService.getTenantCookie(tenantId).catch((err) => {
      console.error(err);
      location.reload();
    });
}

class AppProvider extends React.Component {
  componentDidMount() {
    pageVisibility.subscribe(checkCookieSync);
  }

  componentWillUnmount() {
    pageVisibility.unsubscribe();
  }

  render() {
    return <Provider store={store}>{routes}</Provider>;
  }
}

const AppWrapper = () => {
  return (
    <SecurityWrapper oktaAuth={oktaClient} applicationPath={APPLICATION_PATH}>
      <AppProvider />
    </SecurityWrapper>
  );
};
render(<AppWrapper />, document.getElementById('app'));
